function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M50 5C25.148 5 5 25.148 5 50s20.148 45 45 45 45-20.148 45-45S74.852 5 50 5zM29.605 19.684v-.004a10.491 10.491 0 11-.003 20.982 10.491 10.491 0 01.003-20.982zm30.422 10.488l2.621 1.746-14.512 13.113 7.52 10.664-1.922.524-11.016-10.84 17.309-15.211zm4.547 2.797l6.992 11.539L59.152 57.62l-8.215-12.766zm-45.98 11.367l16.78.348 13.286 19.23c.898 1.351 2.191 1.914 4.02 1.402l10.663-5.945-2.625-.875 12.766-12.762 18.531 3.496-9.617 13.637-6.297-1.047L50.75 79.652c-2.058.73-4.132 1.375-6.644-.176L35.187 65.14l4.723 9.617-.176 16.605c-.067.406-16.95-2.707-26.223-17.484l1.222-26.223c.465-1.723 1.524-2.996 3.848-3.32zm25.352 4.894l6.121 5.418.875 2.625-2.273 2.274-6.641-8.918 1.922-1.399z"
});

function SvgManual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.b99ee59c.svg";
export { ForwardRef as ReactComponent };